import _ from 'underscore';

/**
 * Function to generate a function to filter locations by given countries
 * @param {Array} allowedCountryCodes -  Array of strings with the two-letter ISO country code.
 * @returns {Function} - Returns a function that filters by the allowedCountryCodes,
 * this new function requires a locations parameter.
 */

export const filterResultByCountryCode = (allowedCountryCodes) => {
  const filter = results =>
    _.filter(results, location => _.contains(allowedCountryCodes, location.CountryCode));
  return filter;
};

